// Fallback renderer for any judgment-row check that doesn't have a dedicated evidence
// component yet. The verdict block is now rendered above the collapse boundary by the
// FindingCard, so there's no supporting-data shape this renderer needs to add — it returns
// null and the card renders only the verdict + triage. Kept registered so the
// findEvidenceRenderer dispatcher always has something to return for judgment-row check IDs.

export const GenericLlmJudgmentEvidence = () => null;
